module.exports = __webpack_public_path__ + "img/siren-on.62ac25f1.svg";